module.exports = __webpack_public_path__ + "img/sample_img_intro_01.3688aa83.png";